import { Component, EventEmitter, OnInit, Inject, Output, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { FileQueueObject, FileUploaderService } from '../../services/file-uploader.service'
import { Observable } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { UtilityService } from 'src/app/services/utility.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';


@Component({
  selector: 'app-new-file-modal',
  templateUrl: './new-file-modal.component.html',
  styleUrls: ['./new-file-modal.component.scss']
})
export class NewFileModalComponent implements OnInit {



  @Output() onCompleteItem = new EventEmitter();
  @Output() evidences: EventEmitter<any> = new EventEmitter<any>();
  @Output() competencies: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileInQueue: EventEmitter<any> = new EventEmitter<any>();
  @Input('showFields') showFields;
  @Input('isCompetencies') isCompetencies;

  @ViewChild('fileInput', { static: false }) fileInput;
  queue: Observable<FileQueueObject[]>;
  uploadedFiles = [];
  uploadedFilesCount = 0
  queueCount = 0
  uploadStatus = true
  filesArray: any = [];
  uploadedCount: number = 0;
  format = '.pdf,.mp3,.ppt,.pptx, .doc, .docx ,.mp4,.jpg,.jpeg,.png,.zip,.csv,.mov,.mkv,.txt,.xls,.xlsx,.xlsm'
  isMultiple = true
  isDocument = false;
  isSubmission = false;
  disabled: boolean = true
  count = 0
  constructor(
    public uploader: FileUploaderService,
    public _snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public cd: ChangeDetectorRef,
    public _utilityService: UtilityService,
    public _encryptDecryptService: EncryptDecryptService
  ) {
    this.dialogRef.disableClose = true;

    // let temp = this.uploader.checkedData()
    // console.log(" THis is more important for me  ", temp);

  }

  ngOnInit() {
    console.log("this.data", this.data);

    if (this.data.isSubmission) this.isSubmission = true
    if (this.data.document) this.isDocument = true



    // console.log("%cthis.data", "color:blue", this.data, this.showFields);
    // if (this.showFields) {
    //   this.data['isEvidence'] = true
    // }
    // // if(this.data && this.data.session){
    // //   this.showUploads = false;
    // //   // this.createSessionForm()
    // // }

    // console.log("Upload files initialized", this.queue);
    // setTimeout(function () {
    //   if (this.uploader && this.uploader.queue) {

    //     this.queue = this.uploader.queue;
    //     this.cd.detectChanges()

    //     this.queueCount = 0;
    //     console.log("this.queueCount = ==+> ", this.queueCount);
    //     // this.queueCount = this.queue.source['_value'].length || 0
    //     this.uploader.bodyData = this.data;


    //     this.uploader.onCompleteItem = this.completeItem;
    //     this.uploader.clearQueue()
    //     // here... this has different context
    //   }

    // });
    if (this.data && this.data.isAssetDocument) {
      this.format = '.jpg,.jpeg,.png'
    }

    console.log("%cthis.data", "color:blue", this.data, this.showFields);
    if (this.showFields || this.isCompetencies) {
      this.data['isEvidence'] = true
    }
    if (this.data && this.data.isIncident) {
      this.format = '.jpg,.jpeg,.png'
    }
    if (this.data && (this.data.isCreate || this.data.isCompetency)) {
      this.format = '.csv'
      this.isMultiple = false
    }

    // if (this.data && this.data.isSponsor) {
    //   this.isMultiple = false
    // }
    // if(this.data && this.data.session){
    //   this.showUploads = false;
    //   // this.createSessionForm()
    // }

    console.log("Upload files initialized", this.queue);

    this.queue = this.uploader.queue;
    this.queueCount = 0;
    console.log("this.queueCount = ==+> ", this.queueCount);
    // this.queueCount = this.queue.source['_value'].length || 0
    this.uploader.bodyData = this.data;
    this.uploader.onCompleteItem = this.completeItem;
    this.uploader.clearQueue()
    this.checkSessionStorage()

  }


  checkSessionStorage() {
    const sessionStorageData = JSON.parse(sessionStorage.getItem('auth'))
    if (sessionStorageData) {
      console.log("SESSION storage data: ", sessionStorageData.primary, sessionStorageData.secondary)
    } else {
      this._utilityService.updatePlatformData().subscribe((data) => {
        console.log("SESSION storage data", data)
        const credentials = this._encryptDecryptService.platFormDecrypt(data)
        console.log("SESSION storage credentials: ", credentials)
        sessionStorage.setItem('auth', credentials);
      })
    }
  }





  completeItem = (item: FileQueueObject, response: any, status) => {
    console.log('%cNew file uploaded', "color:blue", response, item, status);

    if (response.body) {
      this.count++;
      if (this.data.document === true) {
        this.dialogRef.close(this.uploadedFiles)
      }
      this.data = response.body.data;

      if (this.uploader.bodyData.competenciesId) {
        this.uploadedFiles.push(response.body)
      }
      else {
        if (this.uploadStatus) {
          this.uploadStatus = false
        } else {
          this.uploadedFilesCount++
        }
        console.log("this.isDocument", this.isDocument, this.queueCount == this.uploadedFilesCount, this.queueCount == this.count);

        if (this.isDocument && (this.queueCount == this.uploadedFilesCount || this.queueCount == this.count)) {
          this.dialogRef.close(this.uploadedFiles)
        }
        if (this.isSubmission && (this.queueCount == this.uploadedFilesCount || this.queueCount == this.count)) {
          this.dialogRef.close(this.uploadedFiles)
        }
        console.log("response.body.data", response.body.data);
        if (this.data.instructors && this.data.instructors.length) this.uploadedFiles = this.data
        else this.uploadedFiles.push(response.body.data.file[0])
        console.log("this.uploadedFiles", this.uploadedFiles);
        this.queueCount = this.queue.source['_value'].length || 0
        console.log("uploadedFilesCount", this.uploadedFilesCount)
        console.log("queueCount", this.queueCount)
      }
    }
    else {
      // this.uploadedCount += 1
      console.log('%c this.uploadedCount', "color:purple", this.uploadedCount, this.queueCount);

      let tempFile = this.filesArray.find((x) => x.ETag === response.ETag)
      console.log("what is temp file data", tempFile);
      // if (tempFile == undefined) {
      //   this._files.push(queueObj);
      // }

      if (tempFile == undefined) {
        this.filesArray.push(response)
      }
      this.uploadedCount = this.filesArray.length
      if (this.uploadedCount == this.queueCount) {
        console.log('%cARRAY READY TO SEND', "color:purple", this.filesArray);
        if (this.data.isEvidence && !this.data.isErPhnCall && !this.isCompetencies) {
          console.log('EMITTING EVENT')
          this.evidences.emit({ files: this.filesArray })
        }
        else if (this.isCompetencies) {
          console.log('EMITTING EVENT')
          this.competencies.emit({ files: this.filesArray })
        }
        else {
          console.log('NO EVENT EMITTEDk')
          this.dialogRef.close(this.filesArray)
        }
      }
      else {
        console.log('%cARRAY WILL BE READY TO SEND', "color:purple");
      }
    }
  }

  addToQueue() {
    const fileBrowser = this.fileInput.nativeElement;
    console.log("what is fileBrowser", fileBrowser);
    if (this.data && (this.data.isCreate || this.data.isCompetency)) {

      console.log("what is the que count", this.queueCount);
      if (this.queueCount == 1) {
        console.log("this is for file replace");
        this.uploader.clearQueue()
        this.uploader.addToQueue(fileBrowser.files);
        console.log("que", this.queue)
        this.queueCount = this.queue.source['_value'].length
        this.fileInQueue.emit({ queCount: this.queueCount })
      } else {
        this.uploader.addToQueue(fileBrowser.files);
        console.log("que", this.queue)
        this.queueCount = this.queue.source['_value'].length
        this.fileInQueue.emit({ queCount: this.queueCount })
      }



    } else {
      this.uploader.addToQueue(fileBrowser.files);
      console.log("que", this.queue)
      this.queueCount = this.queue.source['_value'].length
      this.fileInQueue.emit({ queCount: this.queueCount })
    }
  }

  dragQueue(event) {
    console.log("event when file drop", event);

    this.uploader.addToQueue(event);
    this.queueCount = this.queue.source['_value'].length
    this.fileInQueue.emit({ queCount: this.queueCount })
    console.log("add to queue function call");

  }
  upload(item?) {
    console.log('item', item)
    if (this.uploadStatus && this.uploadedFilesCount == 0) this.uploadedFilesCount++
    console.log("this.uploadedFilesCount++", this.uploadedFilesCount)
    let temp = this.uploader.uploadAll()

  }

  singleUpload() {
    const fileBrowser = this.fileInput.nativeElement;
    console.log("fileBrowser", fileBrowser.files[0]);
    let newFile = new FileQueueObject(fileBrowser.files[0])
    // let temp = this.uploader._upload(newFile)
    this.disabled = false
  }


  close() {
    this.dialogRef.close(this.uploadedFiles)
  }

  removeItem() {

    this.queueCount = this.queueCount - 1
    console.log("new count remove", this.queueCount);


  }


  // createSessionForm(){
  //   this.sessionForm = new FormGroup({
  //     sessionType: new FormControl('',Validators.required),
  //     title: new FormControl('', Validators.required),
  //     unit: new FormControl('')
  //   })
  // }



}
